<script lang="ts">
	import { InputRadios } from '@wiseed/wikit';
	import { beforeUpdate } from 'svelte';
	import type { AppInputRadiosProps } from '@app/types/Inputs';

	export let props: AppInputRadiosProps;

	$: props.handleChangeCallbackFunction = (e) => {
		if (props?.renderSpecificValue) {
			let { id, value } = e.target as HTMLInputElement;
			let dataId = (e.target as HTMLElement).getAttribute('data-id');
			if (dataId) props.specificValue = { id: parseInt(dataId), value };
		}
	};

	beforeUpdate(() => {
		if (props?.renderSpecificValue && props.specificValue) props.value = props.specificValue.value;
	});
</script>

<InputRadios bind:props />
